import { useCallback, useId, useRef, useState } from "react";
import type { KeyboardEvent } from "react";
import type { Tooltip } from "primereact/tooltip";

import { SIMULACAO_SELO } from "./simulacao-marca.constants";
import type { SimulacaoMarcaTagProps, SimulacaoMarcaTagViewModel } from "./types-simulacao-marca";

export function useSimulacaoMarca({ marca }: SimulacaoMarcaTagProps): SimulacaoMarcaTagViewModel {
  const [alvo, setAlvo] = useState<HTMLSpanElement | null>(null);
  const tooltipRef = useRef<Tooltip>(null);
  const tooltipId = useId();

  const aoTeclar = useCallback((evento: KeyboardEvent<HTMLSpanElement>) => {
    if (evento.key === "Escape") tooltipRef.current?.hide();
  }, []);

  return {
    marca,
    selo: SIMULACAO_SELO,
    tooltipId,
    tooltipRef,
    alvo,
    registrarAlvo: setAlvo,
    aoTeclar,
  };
}
